import ApiService from "@/common/api.service"

export const EducationalProgramService = {
    create(params) {
        return ApiService.post("educationalPrograms/add", params);
    },
    update(slug, params) {
        return ApiService.update("educationalPrograms", slug, params);
    },

}